(function($) {

  Drupal.behaviors.aerin_woa_disco_more_v1 = {
    attach: function(context, settings) {
      $('.ee-disco-more__items').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              infinite: false,
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 650,
            settings: {
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

    } // attach
  };

})(jQuery);
